import { useIntl } from 'react-intl';

import { ProductTileModel } from '@notino/react-styleguide';

import { messages } from '@containers/ProductDetailContainer/ProductDetail/ProductBaseInfo/VoucherDiscount/VoucherDiscountInfo/messages';

interface Attributes {
  BlackFridayOfferDiscount?: boolean;
  blackFriday?: boolean;
  christmasOffer?: boolean;
  VoucherDiscount?: {
    productDetailOnly?: boolean;
    theme: string | null;
    tags: string[];
  };
}

function getSpecialSalesAttributes(attributes: Attributes) {
  return Object.keys(attributes)
    .map((key) => {
      if (['BlackFridayOfferDiscount', 'blackFriday'].includes(key)) {
        return ProductTileModel.SpecialSales.blackFriday;
      } else if (key === 'christmasOffer') {
        return ProductTileModel.SpecialSales.christmasOffer;
      } else if (key === 'VoucherDiscount') {
        const voucherDiscount = attributes.VoucherDiscount;
        if (
          voucherDiscount?.productDetailOnly === false &&
          voucherDiscount?.theme === 'SBF'
        ) {
          return ProductTileModel.SpecialSales.summerBlackFriday;
        } else if (voucherDiscount?.tags?.includes('blackfriday')) {
          return ProductTileModel.SpecialSales.blackFriday;
        }
      } else if (key === 'Dermo') {
        return ProductTileModel.SpecialSales.dermo;
      }
      return null;
    })
    .filter(Boolean);
}

function getSpecialSalesLabelText(
  specialSalesAttributes: ProductTileModel.SpecialSales[] = []
) {
  if (
    specialSalesAttributes.some(
      (sale) => sale === ProductTileModel.SpecialSales.blackFriday
    )
  ) {
    return messages.blackFridayLabel;
  } else if (
    specialSalesAttributes.some(
      (sale) => sale === ProductTileModel.SpecialSales.summerBlackFriday
    )
  ) {
    return messages.sbfLabel;
  }
  return null;
}

type SpecialSalesType = [
  specialSalesAttributes: ProductTileModel.SpecialSales[],
  specialSalesText: string | null
];
const DEFAULT: SpecialSalesType = [[], null];

export const useGetSpecialSales = () => {
  const { formatMessage } = useIntl();

  return (attributes: Record<string, unknown>): SpecialSalesType => {
    if (!attributes) return DEFAULT;
    const specialSalesAttributes = getSpecialSalesAttributes(attributes);
    const localizedLabel = getSpecialSalesLabelText(specialSalesAttributes);

    return [
      specialSalesAttributes,
      localizedLabel ? formatMessage(localizedLabel) : null,
    ];
  };
};

export const useSpecialSales = (
  attributes: Record<string, unknown>
): SpecialSalesType => {
  const getSpecialSales = useGetSpecialSales();
  return getSpecialSales(attributes);
};
